module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-green.25ccd998.svg";